define('controllers/consoleApi/serviceAccountKeysAdd.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('ServiceAccountKeysAdd', ['$q','$scope', '$state', '$stateParams', '$rootScope', 'projectManageService','auiDialog',
        function ($q,$scope, $state, $stateParams, $rootScope, projectManageService,auiDialog) {
            var Model = $scope.Model = {
                saForm : {
                },
                submbIsGray : false,
                projectKey : $stateParams.projectKey,
                clientID : $stateParams.clientID,
                selectSC : {},
                selectSCK : {},
                publicKey:''
            };
            var obj   = {};

            Model.isSupportAes = window.msCrypto || window.crypto;


            init();
            $scope.doSubmit = doSubmit;
            $scope.cancel = cancel;
            $scope.createPublicKey = createPublicKey;

            function init() {

                projectManageService.getProjectList().then(function (resp) {
                    if(resp && resp.projectInfoList.length>0){
                        if(Model.projectKey == '0' ){
                            if(projectManageService.getProjectKey() !='0'){
                                $state.go($state.current.name,{projectKey:projectManageService.getProjectKey()}, {reload: true});
                            }else{
                                Model.myProject = Model.projectInfoList[0];
                                projectManageService.setProjectKey(Model.myProject.projectKey);
                                initSAK();
                            }
                        }else{
                            projectManageService.getProjectInfo({projectKey:Model.projectKey}).then(function (data) {
                                if(data && data.projectInfo){
                                    Model.myProject = data.projectInfo;
                                    initSAK();
                                }
                            });
                        }
                    }else{
                        $state.go('myApi',{projectKey:0}, {reload: true});
                    }
                })
            }

            function initSAK(){
                projectManageService.getProjectCredentialList(Model.myProject.projectID, 3).then(function (resp) {
                    if(resp && resp.subAccountInfoList && resp.subAccountInfoList.length>0){
                        if(Model.clientID  != '0'){
                            resp.subAccountInfoList.forEach(function (subAccountInfo) {
                                if(Model.clientID == subAccountInfo.clientID){
                                    Model.selectSC = angular.copy(subAccountInfo);
                                    if(subAccountInfo.publicKeyList && subAccountInfo.publicKeyList.length>0 && false){
                                        Model.selectSC.publicKey = subAccountInfo.publicKeyList[0].publicKey;
                                    }
                                }
                            });
                        }else{
                            $scope.serviceAccountList =[{
                                clientID : -1,
                                serviceAccountNameShow: "新的服务帐号"
                            }];
                            resp.subAccountInfoList.forEach(function (subAccountInfo) {
                                subAccountInfo.serviceAccountNameShow = subAccountInfo.name;
                                //不给展示公钥
                                if(subAccountInfo.publicKeyList && subAccountInfo.publicKeyList.length>0 && false){
                                    //默认取第一个吧
                                    subAccountInfo.publicKey = subAccountInfo.publicKeyList[0].publicKey;
                                }
                                $scope.serviceAccountList.push(subAccountInfo);
                            });
                            Model.selectSC = $scope.serviceAccountList[0];
                        }
                    }else{
                        $scope.serviceAccountList =[{
                            clientID : -1,
                            serviceAccountNameShow: "新的服务帐号"
                        }];
                        Model.selectSC = $scope.serviceAccountList[0];
                    }
                });
            }



            //提交
            function doSubmit(isValid){
                $scope.sakeysForm.$setDirty();
                $scope.sakeysForm.publicKey.$setDirty();
                if(isValid && Model.myProject && Model.myProject.projectID){
                    var defer = $q.defer();
                    if(Model.selectSC.clientID != -1){
                        projectManageService.addSAKey(Model.myProject.projectID,Model.selectSC.clientID,Model.selectSC.publicKey).then(function (resp) {
                            if(resp && resp.resultCode == 0){
                                handleJsonFile(resp.clientID,resp.publicKeyID).then(function () {
                                    defer.resolve();
                                    $state.go('credentials', {projectKey:Model.projectKey}, {reload: true});
                                });
                            }else{
                                defer.resolve();
                            }
                        })
                    }else{
                        var param = {
                            projectID : Model.myProject.projectID,
                            name : Model.selectSC.name,
                            description : Model.selectSC.description,
                            publicKey:Model.selectSC.publicKey
                        }
                        projectManageService.addSubAccount(param).then(function(resp){
                            if(resp && resp.resultCode == 0){
                                handleJsonFile(resp.clientID,resp.publicKeyID).then(function () {
                                    defer.resolve();
                                    $state.go('credentials', {projectKey:Model.projectKey}, {reload: true});
                                });
                            }else{
                                defer.resolve();
                            }
                        }).then(function () {
                            defer.resolve();
                        });
                    }
                    return defer.promise;
                }
            }

            //取消
            function cancel() {
                $state.go('credentials', {projectKey:Model.projectKey}, {reload: true});
            }

            function createPublicKey() {
                if(!Model.isSupportAes) return;
                var defer = $q.defer();
                var cryptoMethod =  window.crypto || window.msCrypto;
                if(window.msCrypto){
                    var config ={
                        name: "RSA-OAEP",
                        modulusLength: 4096, //can be 1024, 2048, or 4096
                        publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
                        hash: {name: "SHA-256"}//can be "SHA-1", "SHA-256", "SHA-384", or "SHA-512"
                    };
                    var keyOp = cryptoMethod.subtle.generateKey(config, true, ['encrypt', 'decrypt']);
                    keyOp.oncomplete = function(e) {
                        var exportKeyOp = cryptoMethod.subtle.exportKey("pkcs8", e.target.result.privateKey);
                        var publicKeyOp = cryptoMethod.subtle.exportKey("spki", e.target.result.publicKey);
                        exportKeyOp.oncomplete=function (private) {
                            Model.private = bin2text(private.target.result);
                        };
                        publicKeyOp.oncomplete =function (public) {
                            Model.selectSC.publicKey = bin2text(public.target.result);
                            Model.publicKey = bin2text(public.target.result);
                            defer.resolve();
                        };
                    };
                }else if(window.crypto){
                    //暂时放这 后面统一放到AUI公共方法
                    cryptoMethod.subtle.generateKey(
                        {
                            name: "RSA-OAEP",
                            modulusLength: 4096, //can be 1024, 2048, or 4096
                            publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
                            hash: {name: "SHA-256"}//can be "SHA-1", "SHA-256", "SHA-384", or "SHA-512"
                        },
                        true, //whether the key is extractable (i.e. can be used in exportKey)
                        ["encrypt", "decrypt"] //must be ["encrypt", "decrypt"] or ["wrapKey", "unwrapKey"]
                    )
                        .then(function(key){
                            //returns a keypair object
                            cryptoMethod.subtle.exportKey(
                                "pkcs8", //can be "jwk" (public or private), "spki" (public only), or "pkcs8" (private only)
                                key.privateKey //can be a publicKey or privateKey, as long as extractable was true
                            )
                                .then(function(keydata){
                                    Model.private = bin2text(keydata);
                                    defer.resolve();
                                })
                                .catch(function(err){
                                });
                            cryptoMethod.subtle.exportKey(
                                "spki", //can be "jwk" (public or private), "spki" (public only), or "pkcs8" (private only)
                                key.publicKey //can be a publicKey or privateKey, as long as extractable was true
                            )
                                .then(function(keydata){
                                    Model.selectSC.publicKey = bin2text(keydata);
                                    Model.publicKey = bin2text(keydata);
                                })
                                .catch(function(err){
                                });

                        })
                        .catch(function(err){
                        });
                }
                return defer.promise;
            }

            function download(filename, data) {
                if(typeof data === 'object'){
                    data = JSON.stringify(data, undefined, 4);
                }
                var blob = new Blob([data], {type: 'text/json'});
                var element = document.createElement('a');
                element.setAttribute('href', window.URL.createObjectURL(blob));
                element.setAttribute('download', filename);
                if (navigator.msSaveBlob) {
                    return navigator.msSaveBlob(blob, filename);
                }
                element.style.display = 'none'
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            }

            function bin2text(bin){
                var array = new Uint8Array(bin ,0 , bin.byteLength);
                var temp="";
                for(var i = 0; i < array.length; ++i){
                    temp += String.fromCharCode(array[i])
                }
                return btoa(temp);
            }
            function handleJsonFile(clientID,publicKeyID) {
                var defer = $q.defer();
                var text ={};
                text.project_id =Model.myProject.projectID;
                text.key_id = publicKeyID;
                text.private_key= (Model.selectSC.publicKey == Model.publicKey) ? ("-----BEGIN PRIVATE KEY-----\n"+Model.private+"\n-----END PRIVATE KEY-----\n"):"";
                text.sub_account = clientID+"";
                text.auth_uri =sysUrlCfg.apiConsole.auth_uri;
                text.token_uri =sysUrlCfg.apiConsole.token_uri;
                text.auth_provider_cert_uri =sysUrlCfg.apiConsole.auth_provider_cert_uri;
                text.client_cert_uri =sysUrlCfg.apiConsole.client_cert_uri +clientID;
                download(Model.myProject.projectID+clientID+"private.json",text);
                auiDialog.success('服务帐号信息已保存到您的计算机',Model.myProject.projectID+clientID+"private.json"+'允许访问您的云端资源，请妥善保存。',function () {
                    defer.resolve();
                });
                return defer.promise;

            }



        }
    ]);
});

